/**
 * DateSeparator
 *
 * Shows "Today", "Yesterday", or a formatted date between message groups.
 */

import { isToday, isYesterday, format } from 'date-fns';

export default function DateSeparator({ date }) {
  let label;
  if (isToday(date)) {
    label = 'Today';
  } else if (isYesterday(date)) {
    label = 'Yesterday';
  } else {
    label = format(date, 'MMMM d, yyyy');
  }

  return (
    <div className="flex items-center justify-center py-3">
      <span className="px-3 py-1 bg-base-200 rounded-full text-xs text-base-content/60 font-medium">
        {label}
      </span>
    </div>
  );
}
